import React from 'react'
import { BeWizrEmbedItem } from '~/models'
import { memo } from '~/ui/component'
import { EmbedView } from '../media'

export interface Props {
  item: BeWizrEmbedItem
}

const BeWizrEmbedItemView = memo('BeWizrEmbedItemView', (props: Props) => {

  const {item} = props

  //------
  // Rendering

  function render() {
    return (
      <EmbedView embed={item.embedJson}/>
    )
  }

  return render()

})

export default BeWizrEmbedItemView